module.exports = __webpack_public_path__ + "static/media/logo_cuc3.2617ae6a.png";